import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import {
    IconButton,
    Button,
    CardContent,
    CardActions,
    Typography,
} from '@mui/material';
import { useNotification } from '../../contexts/NotificationsContext';
import { ContextGlobalFeatures } from '../../contexts/GlobalFeatures';
import { encodeFormUrl } from '../../utils/encodeFormUrl';
import { logIn, lastPageVisitedKey } from '../../utils/authHelpers';
import conejoLogin from '../../images/zinantis-logo.png';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import routes from '../../utils/commonVariables/routes';
import useTranslate from '../../customHooks/useTranslate';
import Card from '../../muiComponents/Card';
import TextInput from '../../muiComponents/TextInput/TextInput';
import BunnyLoading from '../../components/BunnyLoading';
import { FeedbackMessages } from '../../utils/commonVariables/messages';

export default function FormLogin() {
    const translate = useTranslate();
    const { setErrorMessage } = useNotification();
    const { isLoadingInterface, setIsLoadingInterface } = useContext(
        ContextGlobalFeatures
    );
    const [inputsData, setInputsData] = useState({
        username: '',
        password: '',
    });
    const { username, password } = inputsData;
    const [validated, setValidated] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleLogIn = async () => {
        setValidated(true);
        if (username && inputsData.password) {
            const formBody = encodeFormUrl({
                username: username.trim(),
                password: password.trim(),
            });
            try {
                setIsLoadingInterface(true);
                const loggedIn = await logIn(formBody);
                if (loggedIn) {
                    const lastPageVisited =
                        localStorage.getItem(lastPageVisitedKey) ||
                        routes.landingPrivate;
                    window.location = lastPageVisited;
                } else {
                    setIsLoadingInterface(false);
                    setErrorMessage(FeedbackMessages.WRONG_CREDENTIALS);
                }
            } catch (_error) {
                console.log(_error);
                setIsLoadingInterface(false);
                setErrorMessage(FeedbackMessages.WRONG_CREDENTIALS);
            }
        }
    };

    const handleChangeInput = event => {
        const { value, name } = event.target;
        setInputsData({
            ...inputsData,
            [name]: value,
        });
    };

    const logInTitleText = translate('hotels_log_in');
    const requiredText = translate('required');
    const passwordText = translate('password');
    const logInText = translate('log_in');
    const forgotPasswordText = translate('i_forgot_my_password');
    const newText = translate('are_you_new');
    const signUpText = translate('sign_up_here');
    const userText = translate('user');

    return (
        <>
            {isLoadingInterface ? (
                <BunnyLoading />
            ) : (
                <div className='flex-column flex-center flex-align-center'>
                    <Card
                        className='flex-column gap-10'
                        sx={{
                            width: 380,
                            padding: '40px 50px',
                        }}
                    >
                        <CardContent className='padding0 gap-20 flex-column flex-center flex-align-center'>
                            <img
                                alt={'Zinantis logo'}
                                src={conejoLogin}
                                height={120}
                            />
                            <Typography variant='h1'>
                                {logInTitleText}
                            </Typography>

                            <TextInput
                                required
                                labelText={userText}
                                handleChange={e => handleChangeInput(e)}
                                name='username'
                                id='username'
                                value={username}
                                errorMessage={
                                    validated && !username ? requiredText : ''
                                }
                            />
                            <TextInput
                                required
                                labelText={passwordText}
                                handleChange={e => handleChangeInput(e)}
                                name='password'
                                id='password'
                                value={password}
                                type={showPassword ? 'text' : 'password'}
                                errorMessage={
                                    validated && !password ? requiredText : ''
                                }
                                suffix={
                                    <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={() =>
                                            setShowPassword(
                                                prevState => !prevState
                                            )
                                        }
                                        onMouseDown={e => e.preventDefault()}
                                        edge='end'
                                    >
                                        {showPassword ? (
                                            <VisibilityOff />
                                        ) : (
                                            <Visibility />
                                        )}
                                    </IconButton>
                                }
                            />
                        </CardContent>
                        <CardActions className='flex-column flex-center flex-align-center'>
                            <Button
                                size='small'
                                variant='contained'
                                onClick={() => handleLogIn()}
                            >
                                {logInText}
                            </Button>
                            <Link
                                to={routes.forgotPassword}
                                className='linkStyleLogin'
                            >
                                <Typography
                                    style={{
                                        marginTop: '10px',
                                        display: 'block',
                                    }}
                                    variant='body1'
                                >
                                    {forgotPasswordText}
                                </Typography>
                            </Link>
                            <Typography
                                style={{
                                    marginTop: '10px',
                                    display: 'block',
                                }}
                            >
                                {newText}
                                <Link
                                    to={routes.signUp}
                                    className='linkStyleLogin'
                                >
                                    {signUpText}.
                                </Link>
                            </Typography>
                        </CardActions>
                    </Card>
                </div>
            )}
        </>
    );
}
